import { render, staticRenderFns } from "./ClientSitesPage.vue?vue&type=template&id=fdbb6b88&"
import script from "./ClientSitesPage.vue?vue&type=script&lang=js&"
export * from "./ClientSitesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdbb6b88')) {
      api.createRecord('fdbb6b88', component.options)
    } else {
      api.reload('fdbb6b88', component.options)
    }
    module.hot.accept("./ClientSitesPage.vue?vue&type=template&id=fdbb6b88&", function () {
      api.rerender('fdbb6b88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ClientSitesPage.vue"
export default component.exports